export default __webpack_public_path__ + "static/media/babajide.230362a0.png";